// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  font-family: "Montserrat", sans-serif !important;
}

body {
  -webkit-font-smoothing: antialiased;
}

hr {
  height: 1px;
  background: #444343;
  border: none;
}

.dob-label {
  margin-top: 20px;
}

.top-label {
  color: #19608f;
  font-size: 1.2rem;
  font-weight: 600;
  padding: none;
}

.top-label-secondary-text {
  color: #19608f;
  margin-bottom: 15px;
  font-weight: 500;
}

.disabledColor {
  background: rgb(227, 227, 227);
  opacity: 0.6;
  color: black;
  font-weight: 600;
}

.gutter-80 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 80%;
}

.gutter-90 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 90%;
}

.gutter-96 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 96%;
}

.grade-gutter-90 {
  max-width: 1800px;
  margin: 0 auto;
  width: 90%;
}
.grade-gutter-90 .will-be {
  text-decoration: underline;
}
.grade-gutter-90 .bold {
  font-weight: 650;
}
.grade-gutter-90 .yellow-box {
  border-radius: 4px;
  background: #FEBF31;
  padding: 3px 5px;
  font-weight: 600;
}

.out-of-bounds-container {
  display: flex;
  flex-direction: row;
  height: 500px;
  justify-content: center;
  width: 100%;
}
.out-of-bounds-container .out-of-bounds {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  align-items: center;
  background: #D1D3D4;
  border: 2px solid #A7A9AC;
  display: flex;
  flex-direction: column;
  height: 50%;
  padding: 50px;
  width: 80%;
}
.out-of-bounds-container hr {
  color: #444343;
  width: 90%;
}

@media only screen and (max-width: 1080px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
@media only screen and (max-width: 926px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
@media only screen and (max-width: 926px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
@media only screen and (max-width: 926px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
.entire-webpage {
  zoom: 2;
  -moz-transform: scale(2);
  /* Firefox Property */
  -moz-transform-origin: 0 0;
  -o-transform: scale(2);
  /* Opera Property */
  -o-transform-origin: 0 0;
  -webkit-transform: scale(2);
  /* Safari Property */
  -webkit-transform-origin: 0 0;
  transform: scale(2);
  /* Standard Property */
  transform-origin: 0 0;
  /* Standard Property */
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/global/Global.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADA;EACI,gDAAA;AAIJ;;AAAA;EACI,mCAAA;AAGJ;;AAAA;EACI,WAAA;EACA,mBDiBK;EChBL,YAAA;AAGJ;;AAAA;EACI,gBAAA;AAGJ;;AAAA;EACI,cDhBM;ECiBN,iBAAA;EACA,gBAAA;EACA,aAAA;AAGJ;;AAAA;EACI,cDvBM;ECwBN,mBAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,8BAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAGJ;;AAAA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAGJ;;AAAA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAGJ;;AAAA;EACI,iBAAA;EACA,cAAA;EACA,UAAA;AAGJ;AADI;EACI,0BAAA;AAGR;AAAI;EACI,gBAAA;AAER;AACI;ECzEA,kBD0EuC;EACnC,mBDvDI;ECwDJ,gBAAA;EACA,gBAAA;AACR;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAAJ;AAEI;ECxFA,mBDyFuC;ECpEvC,2CAAA;EDsEI,mBAAA;EACA,mBDrEA;ECsEA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AAAR;AAGI;EACI,cD1EC;EC2ED,UAAA;AADR;;AAKA;EACI;IACI,iBAAA;IACA,gBAAA;EAFN;AACF;AAMA;EACI;IACI,iBAAA;IACA,gBAAA;EAJN;AACF;AAQA;EACI;IACI,iBAAA;IACA,gBAAA;EANN;AACF;AAUA;EACI;IACI,iBAAA;IACA,gBAAA;EARN;AACF;AAWA;EACI,OAAA;EACA,wBAAA;EACA,qBAAA;EACA,0BAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,2BAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AATJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
